module.exports = __webpack_public_path__ + "static/media/terrace-1.5d601cfc.jpg";